<template>
  <section style="padding: 0;">
    <section class="pagelayout" :class="{ 'pagelayout': !Large, 'pagelayoutAlternative': Large }">
      <div style="width: 100%; position: relative;">
        <div class="shadowDrop">   
        </div>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  props:["alternative"],
  data(){
    return{
      Large: this.alternative
    }
  }
}
</script>

<style scoped>
.pagelayout {
  display: flex;
  justify-content: center;
  width: 100%;
  background-image: linear-gradient(to right, #6f42c1 0%, #e83e8c);
  height: 14px;
}
.pagelayoutAlternative {
  display: flex;
  justify-content: center;
  width: 100%;
  background-image: linear-gradient(to right, #6f42c1 0%, #e83e8c);
  height: 8px;
}

.shadowDrop {
  height: 32px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient(to bottom,
  #1b1c1e20,
  #1b1c1e00)
}

</style>
